import { useUnit } from 'effector-react';
import { 
  userStore, 
  activationStore, 
  telegramStore,
  loadingStore,
  termsStore,
  sessionStore,
  campaignStore,
  rewardStore,
  checkUserExistsFx,
  upsertUserFx,
  activateQrCodeFx,
  initializeTelegramFx,
  submitTermsAgreementFx,
  getCampaignSettingsFx,
  getRewardFx,
  submitTermsAgreement
} from '../stores';

// Хуки для получения состояния
export const useUserStore = () => useUnit(userStore);
export const useActivationStore = () => useUnit(activationStore);
export const useTelegramStore = () => useUnit(telegramStore);
export const useLoadingStore = () => useUnit(loadingStore);
export const useTermsStore = () => useUnit(termsStore);
export const useSessionStore = () => useUnit(sessionStore);
export const useCampaignStore = () => useUnit(campaignStore);
export const useRewardStore = () => useUnit(rewardStore);

// Хуки для получения статуса эффектов
export const useCheckUserExistsPending = () => useUnit(checkUserExistsFx.pending);
export const useUpsertUserPending = () => useUnit(upsertUserFx.pending);
export const useActivateQrCodePending = () => useUnit(activateQrCodeFx.pending);
export const useInitializeTelegramPending = () => useUnit(initializeTelegramFx.pending);
export const useSubmitTermsAgreementPending = () => useUnit(submitTermsAgreementFx.pending);
export const useGetCampaignSettingsPending = () => useUnit(getCampaignSettingsFx.pending);
export const useGetRewardPending = () => useUnit(getRewardFx.pending);

// Экспортируем события для использования в компонентах
export { submitTermsAgreement };

// Ошибки можно получить через useStore для failData, но это требует дополнительной настройки
// Пока используем обработку ошибок через try-catch в компонентах
